<template>
  <div class="footer">
    <div>
      <span class="bb" @click="$router.push('/agreement')">用户协议</span> |
      <span class="bb" @click="$router.push('/agreement')">隐私政策</span> |
      <span class="bb" @click="$router.push('/about')">关于我们</span> |
      <span class="bb" @click="$router.push('/myShop/feedback')">意见反馈</span>
      |
      <span class="bb" @click="helpMes">帮助中心</span>
    </div>
    <div>
      <span>Copyright</span>
      <span> ©</span>
      <span>331教育 版权所有</span>
      <a href="https://beian.miit.gov.cn" style="color:#FFF;" target="_blank"
        >备案号：滇ICP备2020008997号-1</a
      >
      <a
        href=" "
        rel="noreferrer"
        target="_blank"
        style="
    padding-left: 20px;
"
        ><img
          src="../assets/images/galogo.png"
          alt=""
        />滇公网安备53010002000272号</a
      >
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    helpMes() {
      window.open("http://wiki.hwxxkj.com:8089/docs/show/2405");
    }
  }
};
</script>

<style>
.bb {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue